import { render, staticRenderFns } from "./MedecinDetailEvaluationedit.vue?vue&type=template&id=a6bb4ddc&"
import script from "./MedecinDetailEvaluationedit.vue?vue&type=script&lang=js&"
export * from "./MedecinDetailEvaluationedit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports